import { useEffect, useState } from "react";
import { Community } from "../../types/Community";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import {
  hasLegacyCommunityReelCreatorConfig,
  migrateLegacyCommunityReelCreatorConfig,
  stripLegacyCommunityReelCreatorConfig,
} from "./reelCreatorConfig";
import {
  hasLegacyCommunityMedia,
  migrateLegacyCommunityMedia,
  stripLegacyCommunityMedia,
} from "./communityMedia";

type Options = {
  communityId?: string;
};

export const useAllCommunities = ({ communityId }: Options = {}) => {
  const [communities, setCommunities] = useState<Community[]>([]);

  useEffect(() => {
    const collectionRef = firestore.collection(DB_PATH.COMMUNITY);

    const query = communityId
      ? collectionRef.where("id", "==", communityId)
      : collectionRef;

    const unsubscribe = query.onSnapshot(
      (snapshot) => {
        const communitiesData = snapshot.docs.map((doc) => {
          const data = (doc.data() || {}) as Record<string, unknown>;
          if (hasLegacyCommunityReelCreatorConfig(data)) {
            void migrateLegacyCommunityReelCreatorConfig(doc.id, data);
          }
          if (hasLegacyCommunityMedia(data)) {
            void migrateLegacyCommunityMedia(doc.id, data);
          }
          const sanitizedData = stripLegacyCommunityMedia(
            stripLegacyCommunityReelCreatorConfig(data)
          ) as unknown as Community;
          return { ...sanitizedData, id: sanitizedData.id || doc.id };
        });

        setCommunities(communitiesData);
      },
      (error) => {
        console.error("Error fetching communities", error);
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return communities;
};
